<template>
    <div class="alert" v-if="alerts.length > 0">
        <transition-group name="alert-list">
            <div class="alert__inner" v-for="alert in alerts" :key="alert.id">
                <div class="alert__item" :class="alertClass(alert.type)">
                    <div class="alert__content">
                        <div class="alert__close" @click="hideAlert(alert.id)"></div>
                        <div class="alert__img" :class="alert.type"></div>
                        <div class="alert__title">
                            {{alert.text}}
                        </div>
                    </div>
                </div>
            </div>
        </transition-group>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    export default {
        data() {
            return {}
        },
        methods: {
          alertClass(type) {
              return {
                  'is-error': type === 'error'
              }
          },
          hideAlert(id) {
              this.$store.dispatch('REMOVE_ALERT', id)
          }

        },
        computed: {
            ...mapGetters([
                'alerts'
            ]),
        }
    }
</script>

<style lang="sass" scoped>
    .alert
        width: 300px
        position: fixed
        z-index: 1000
        bottom: 8px
        right: 8px
        display: flex
        flex-direction: column
        &__content
            display: flex
            align-items: center
        &__inner
            width: 100%
            &:not(:first-of-type)
                margin-top: 16px
        &__item
            animation: 0.6s alternate alert
            width: 100%
            position: relative
            max-width: 320px
            background: $color--white
            padding: 14px 16px
            border-radius: 4px
            z-index: 1001
            &.is-error
                border: 2px solid $color--burnt
                box-shadow: 2px 4px 8px rgba(235, 94, 85, 0.1)
        &__title
            font-size: 16px
            line-height: 20px
            color: $color--dark
            +reg
            margin-left: 12px
        &__close
            position: absolute
            right: 8px
            top: 8px
            width: 18px
            height: 18px
            padding: 5px
            opacity: 0.3
            +tr(opacity .3s ease)
            cursor: pointer
            &:hover
                opacity: 1
            &:before,
            &:after
                position: absolute
                left: 9px
                top: 3px
                content: ' '
                height: 13px
                width: 2px
                background-color: #01254E
            &:before
                transform: rotate(45deg)
            &:after
                transform: rotate(-45deg)
        &__img
            width: 35px
            height: 35px
            background-size: contain
            background-repeat: no-repeat
            &.error
                background-image: url('~@/assets/img/errors/error.svg')
                background-color: transparent!important
                border-color: transparent!important
    .alert-list-item
        transition: all 0.6s
    .alert-list-enter, .alert-list-leave-to
        opacity: 0
        transform: translate(40px, 0)
    .alert-list-move
        transition: transform 0.6s, opacity 0.6s
    .alert-list-leave-active
        position: absolute

    @keyframes alert
        0%
            transform: translateX(100%)
        100%
            transform: translateX(0)

</style>